module.exports = {"consumptionLabel":"Tipos Consumo","indicatorLabel":{"fuel":"Abastecimento","park":"Estacionamento","toll":"Pedágio"}}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/ConsumptionChartPos/data.json
// module id = 1900
// module chunks = 0